import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaSun, FaWhatsapp } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import SUMMER_CAMPAIGN, { isCampaignActive } from '../../Data/campaignConfig';
import klimaImage from '../../images/air-conditioning.jpg';
import './SummerCampaignSection.css';

const SummerCampaignSection = () => {
  if (!isCampaignActive(SUMMER_CAMPAIGN)) return null;

  const whatsappHref = SITE.whatsappMessage(SUMMER_CAMPAIGN.whatsappText);

  return (
    <section className="summer-campaign-section" aria-labelledby="summer-campaign-heading">
      <div className="scs-container card">
        <div className="scs-image-wrap">
          <img
            src={klimaImage}
            alt="Profesyonel detaylı klima bakımı - yaz kampanyası"
            className="scs-image"
            loading="lazy"
          />
          <div className="scs-price-badge scs-price-pulse" aria-label={`Kampanya fiyatı ${SUMMER_CAMPAIGN.priceDisplay}`}>
            {SUMMER_CAMPAIGN.priceDisplay}
          </div>
        </div>

        <div className="scs-content">
          <span className="scs-label">
            <FaSun aria-hidden /> {SUMMER_CAMPAIGN.title} · Son gün: {SUMMER_CAMPAIGN.endDateDisplay}
          </span>

          <h2 id="summer-campaign-heading" className="scs-title">
            {SUMMER_CAMPAIGN.serviceName}
          </h2>

          <p className="scs-desc">
            Yaz aylarında klimanızın verimli ve sağlıklı çalışması için profesyonel
            detaylı bakım paketi. Sınırlı süre kampanya fiyatıyla aynı gün servis imkanı.
          </p>

          <ul className="scs-checklist">
            {SUMMER_CAMPAIGN.checklist.map((item) => (
              <li key={item}>
                <FaCheckCircle aria-hidden />
                {item}
              </li>
            ))}
          </ul>

          <div className="scs-price-row">
            <span className="scs-price-label">Kampanya fiyatı</span>
            <span className="scs-price scs-price-pulse">{SUMMER_CAMPAIGN.priceDisplay}</span>
          </div>

          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-whatsapp scs-actions"
          >
            <FaWhatsapp className="btn-icon" /> Kampanyadan Yararlan
          </a>

          <Link to={SUMMER_CAMPAIGN.detailPath} className="scs-detail-link">
            Detaylı bilgi →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SummerCampaignSection;
